// The customer's contact details, as the rest of the app needs them.
//
// Google or Facebook authenticate the customer; they do not always supply the details we send an
// invoice to. A Facebook account registered to a phone number has no email, and a customer may
// untick it on the consent screen. So the rule is: take what the provider gave, and ask on the
// profile page for whatever it did not — name, email and mobile are all required before payment.
// Mirrors `core.customer_record.contact_email` and `core.lifecycle.missing_customer_info` on the
// server, which is the actual enforcement.

// Where invoices and notifications go: the address typed in the profile, else the provider's.
export const contactEmail = (u) => String(u?.contact_email || u?.email || "").trim();

// Which of the three the account still lacks, in words for a sentence. Address is deliberately not
// here: it is needed for a courier, not to reach the customer, and the cart asks for it itself.
export const missingContact = (u) => [
  !String(u?.name || "").trim() && "full name",
  !contactEmail(u) && "email address",
  !String(u?.mobile || "").trim() && "mobile number",
].filter(Boolean);
